import { $can } from '@pendo/permissions';

export function hasAppDetailsViewerAccessForAppId (id) {
    return $can(id).entity('applicationDetails').action('view');
}

export function hasAppDetailsEditorAccessForAppId (id) {
    return $can(id).entity('applicationDetails').action('edit');
}

export function hasInstallationSettingsViewerAccessForAppId (id) {
    return $can(id).entity('installationSettings').action('view');
}

export function hasInstallationSettingsEditorAccessForAppId (id) {
    return $can(id).entity('installationSettings').action('edit');
}

export function hasRawEventsViewerAccessForAppId (id) {
    return $can(id).entity('rawEvent').action('view');
}

export function hasSessionReplayViewerAccessForAppId (id) {
    return $can(id).entity('sessionReplay').action('view');
}

export function hasSessionReplayEditorAccessForAppId (id) {
    return $can(id).entity('sessionReplay').action('edit');
}

export function hasWebSdkSettingsViewerAccessForAppId (id) {
    return $can(id).entity('webSdkSettings').action('view');
}

export function hasWebSdkSettingsEditorAccessForAppId (id) {
    return $can(id).entity('webSdkSettings').action('edit');
}

export function hasLocalizationSettingsViewerAccessForAppId (id) {
    return $can(id).entity('localizationSettings').action('view');
}

export function hasLocalizationSettingsEditorAccessForAppId (id) {
    return $can(id).entity('localizationSettings').action('edit');
}

export function hasTaggingAndGuideSettingsViewerAccessForAppId (id) {
    return $can(id).entity('taggingAndGuideSettings').action('view');
}

export function hasTaggingAndGuideSettingsEditorAccessForAppId (id) {
    return $can(id).entity('taggingAndGuideSettings').action('edit');
}

export function hasManagementAccessForAppIds (ids) {
    return ids.some(hasManagementAccessForAppId);
}

export function hasManagementAccessForAppId (id) {
    return (
        hasAppDetailsViewerAccessForAppId(id)
        || hasInstallationSettingsViewerAccessForAppId(id)
        || hasRawEventsViewerAccessForAppId(id)
        || hasLocalizationSettingsViewerAccessForAppId(id)
    );
}
